import { ApiOptions } from '../../api-options.decorator';
import { DefaultParams } from '../../default-params.model';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBasePortal } from './base';

/**
 * @internal
 */
export class ApiPortal extends ApiBasePortal {
  @ApiOptions({ channel: 'emailSubscriptionPut' })
  putEmailSubscription(dagId: string, contactId: number) {
    return this.put(`/portal/email-subscriptions/${dagId}/${contactId}`);
  }

  @ApiOptions({ channel: 'emailSubscriptionDelete', interceptErrors: false })
  deleteEmailSubscription(dagId: string, contactId: number) {
    return this.delete(`/portal/email-subscriptions/${dagId}/${contactId}`);
  }

  @ApiOptions({ channel: 'emailSubscriptionGet', interceptErrors: false })
  getSummaryReportSubscription(dagId: string, contactId: number) {
    return this.get(`/portal/email-subscriptions/${dagId}/${contactId}`);
  }

  getEnergyScanDailyNews() {
    return this.get(`/portal/energy-scan/daily-analysis`);
  }

  @ApiOptions({ channel: 'notificationGet', showSpinner: false, reloadIgnore: true })
  getNotifications(params: ParamsAdapter) {
    return this.get('/portal/notifications', params);
  }

  @ApiOptions({ channel: 'notificationMarkAsRead' })
  markNotificationAsRead(id: number, params: ParamsAdapter) {
    return this.patch(`/portal/notifications/${id}`, params);
  }

  @ApiOptions({ channel: 'thread.delete' })
  removeThread(threadId: number) {
    return this.delete(`/portal/thread/${threadId}`);
  }

  @ApiOptions({ channel: 'thread.patch' })
  editThread(threadId: number, params: ParamsAdapter) {
    return this.patch(`/portal/thread/${threadId}`, params);
  }

  @ApiOptions({ channel: 'thread.post' })
  createThread(params: ParamsAdapter) {
    return this.post(`/portal/thread`, params);
  }

  @ApiOptions({ channel: 'thread.get', reloadIgnore: true })
  getThread(id: number, params: ParamsAdapter = new DefaultParams()) {
    return this.get(`/portal/thread/${id}`, params);
  }

  @ApiOptions({ channel: 'thread.list', reloadIgnore: true })
  getThreads(params: ParamsAdapter = new DefaultParams()) {
    return this.get('/portal/thread', params);
  }

  @ApiOptions({ channel: 'thread.post' })
  postComment(threadId: number, params: ParamsAdapter) {
    return this.post(`/portal/thread/${threadId}/reply`, params);
  }

  @ApiOptions({ channel: 'replyRemove' })
  removeComment(commentParentId: number, commentId: number) {
    return this.delete(`/portal/thread/${commentParentId}/reply/${commentId}`);
  }

  @ApiOptions({ channel: 'threadFile', responseType: 'blob' })
  getFileFromLink(threadId: number, fileId: number) {
    return this.get<Blob>(`/portal/thread/${threadId}/files/${fileId}`);
  }

  @ApiOptions({ channel: 'threadFile', responseType: 'blob' })
  getFileFromThreadReplyLink(threadId: number, commentId: number, fileId: number) {
    return this.get<Blob>(`/portal/thread/${threadId}/reply/${commentId}/files/${fileId}`);
  }
}
